import { LegacyBookInitService } from 'modules/shared/legacy-bookexpress/services/legacy-book-initializer.service';
import { Injectable } from '@angular/core';
import { SelectedEnhancements } from 'model/wbe/backend-api-response/selected-enhancements';
import { Guid } from 'guid-typescript';

declare let ga: Function;
declare const gtag: Function;
declare global {
  interface Window {
    dataLayer: any;
  }
}
@Injectable()
export class GoogleAnalyticsEventsService {
  public ignoreEventActionList = [
    // only for agilysys account
    'CasinoNumber',
    'GuestFirstName',
    'GuestLastName',
  ];
  gaArray = [];
  constructor(public _conf: LegacyBookInitService) {}
  validateAction(eventAction) {
    let action = this.ignoreEventActionList.find((elm) => {
      return elm === eventAction;
    });
    if (action) {
      return false;
    } else return true;
  }

  get casinoId() {
    const propertyId = this._conf?.propertyId;
    const tenantId = this._conf?.tenantId;

    const casinoDetails = localStorage.getItem(`${tenantId}-${propertyId}-Casino`);
    if (casinoDetails) {
      return JSON.parse(casinoDetails)?.casinoNumber;
    }
  }

  get secondaryPlayerCasinoId() {
    try {
      const secondaryCasinoDetails = localStorage.getItem(`${this._conf.tenantId}-${this._conf.propertyId}-casinoPlayerToken`);
      return secondaryCasinoDetails ? JSON.parse(secondaryCasinoDetails) : [];
    } catch (error) {
      return [];
    }
  }

  triggerGoogleEvents(eventName?, data?): void {
    if (!data?.hasOwnProperty('affiliation')) {
      data['affiliation'] = this._conf?.propertyId;
    }

    if (!data?.hasOwnProperty('item_brand')) {
      data['item_brand'] = this._conf?.tenantId;
    }

    if (!data?.hasOwnProperty('casino_Id') && this.casinoId) {
      data['casino_Id'] = this.casinoId;
    }

    if (!data?.hasOwnProperty('secondary_player_casino_Id') && this.secondaryPlayerCasinoId?.length > 0) {
      data['secondary_player_casino_Id'] = this.secondaryPlayerCasinoId?.map((id: any) => ({ id: id?.casinoNumber }));
    }

    const ga4Data = !!sessionStorage.getItem('GA4Data') && JSON.parse(sessionStorage.getItem('GA4Data'));
    if (ga4Data?.gaCustomerId && ga4Data?.gaAgilysysId && this._conf?.isCookiePolicyAcceptanceRequired && this._conf.policyCookie) {
      data['send_to'] = [ga4Data?.gaCustomerId, ga4Data?.gaAgilysysId];
      gtag('event', eventName, data);
    } else if (!this._conf?.isCookiePolicyAcceptanceRequired && ga4Data?.gaCustomerId && ga4Data?.gaAgilysysId) {
      data['send_to'] = [ga4Data?.gaCustomerId, ga4Data?.gaAgilysysId];
      gtag('event', eventName, data);
    }

    if (!ga4Data?.gaCustomerId && ga4Data?.gaAgilysysId && this._conf?.isCookiePolicyAcceptanceRequired && this._conf.policyCookie) {
      data['send_to'] = ga4Data?.gaAgilysysId;
      gtag('event', eventName, data);
    } else if (!this._conf?.isCookiePolicyAcceptanceRequired && ga4Data?.gaAgilysysId && !ga4Data?.gaCustomerId) {
      data['send_to'] = ga4Data?.gaAgilysysId;
      gtag('event', eventName, data);
    }
    if (!ga4Data) {
      this.gaArray.push({ data: data, eventName: eventName });
    }
  }

  eventEmitter(eventName: string, eventCategory: string, eventAction: string, eventLabel: string = null, eventValue: number = null): void {
    this.triggerGoogleEvents(eventName, {
      event_category: eventCategory,
      event_label: eventLabel,
      event_action: eventAction,
      event_value: eventValue,
    });
  }

  addToCartGA4(data, casinoId?, offerCode?): void {
    const transactionData = {
      currency: '',
      value: 0, // Grand Total.
      tax: 0,
      ...(!!casinoId && { casino_Id: casinoId }),
    };
    let itemData = [];

    transactionData['value'] = transactionData['value'] + (data?.value || data?.grandTotal);
    transactionData['currency'] = data?.currency;
    transactionData['tax'] = transactionData['tax'] + data?.quoteTotalTax || data?.tax;
    transactionData['booking_type'] = data?.cart_type;
    transactionData['affiliation'] = this._conf?.propertyId;
    itemData.push({
      item_id: data?.SKU,
      item_name: data?.itemName,
      affiliation: this._conf?.propertyId,
      coupon: offerCode || data?.coupon,
      currency: data?.currency,
      item_brand: this._conf?.tenantId,
      item_category: data?.cart_type,
      price: data?.quoteTotal || data?.price,
      tax: data?.quoteTotalTax || data?.tax,
      quantity: 1,
    });
    transactionData['items'] = itemData;
    this.triggerGoogleEvents('add_to_cart', transactionData);
  }

  purchaseEvent(data, currencyCode, casinoId?, propertyName?): void {
    const transactionData = {
      transaction_id: '', // Transaction ID.
      affiliation: '', // Property ID.
      value: 0, // Grand Total.
      tax: 0, // Tax.
      currency: '',
      ...(!!casinoId && { casino_Id: casinoId }),
    };
    let itemData = [];

    data?.forEach((item) => {
      if (item.Success && item.confirmationId) {
        let findIndex = -1;
        const guestKey = this.getGuests(item?.stayInfo?.guestCounts);
        console.log(guestKey);
        let match = itemData.filter((e, index) => {
          if (
            e.item_id ===
              `SKU_Room_${item.roomDetails.offerCode}_${item.roomDetails.room.roomCode}_${item.roomDetails.arrival}_${item.roomDetails.departure}_${guestKey}` &&
            e.item_category == 'room'
          ) {
            findIndex = index;
            return true;
          } else return false;
        });
        if (match.length <= 0) {
          itemData.push({
            item_name: item.roomDetails.room.roomName, // Product name.
            item_id: `SKU_Room_${item?.roomDetails?.offerCode}_${item?.roomDetails?.room?.roomCode}_${item?.roomDetails?.arrival}_${item?.roomDetails?.departure}_${guestKey}`, // SKU
            affiliation: this._conf?.propertyId,
            item_category: 'room', // Category or variation.
            currency: currencyCode,
            item_brand: this._conf?.tenantId,
            coupon: item?.roomDetails?.offerCode,
            price: item?.roomDetails?.room?.roomTotal || item.roomDetails?.room?.quoteGrandTotal, // Unit price.
            quantity: 1, // Quantity.
          });
        } else {
          itemData[findIndex].quantity++;
        }

        transactionData.affiliation = this._conf?.propertyId;
        transactionData.transaction_id = String(Guid.create());
        transactionData.currency = currencyCode;
        transactionData['coupon'] = item?.roomDetails?.offerCode;
        transactionData.value =
          transactionData?.value + item?.roomDetails?.room?.quoteTotal || item.roomDetails?.room?.ecommercePrice?.quoteTotal;
        transactionData.tax = transactionData?.tax + transactionData?.tax + item.roomDetails?.room?.quoteTotalTax;
        transactionData['booking_type'] = 'room';

        item?.roomDetails?.SelectedEnhancements?.forEach((enhancement: SelectedEnhancements) => {
          transactionData.tax = transactionData.tax + enhancement?.recurringChargeTaxTotal + transactionData?.tax;
          transactionData.value = transactionData?.value + enhancement?.recurringChargeTotal;
          transactionData['booking_type'] = 'room + enhancement';

          let findIndex = -1;
          let match = itemData.filter((e, index) => {
            if (e.item_id === `SKU_Enhancement_${enhancement.requestCode}_${guestKey}` && e.item_category === 'room_enhancement') {
              findIndex = index;
              return true;
            } else {
              return false;
            }
          });
          if (match.length <= 0)
            itemData.push({
              item_name: enhancement.requestDescription, // Product name.
              item_id: `SKU_Enhancement_${enhancement.requestCode}_${guestKey}`, // SKU
              item_category: 'room_enhancement', // Category or variation.
              affiliation: this._conf?.propertyId,
              item_brand: this._conf?.tenantId,
              tax: enhancement.recurringChargeTaxTotal,
              price: enhancement.recurringChargeTotal, // Unit price.
              quantity: 1, // Quantity.
            });
          else {
            itemData[findIndex].quantity++;
          }
        });
        transactionData['items'] = itemData;
        this.triggerGoogleEvents('purchase', transactionData);
      }
    });
  }

  pushGTAToDataLayer(data) {
    if ((!data?.hasOwnProperty('casinoId') || data['casinoId'] === 'NA') && this.casinoId) {
      if (this.casinoId.toLowerCase() !== 'NA'.toLowerCase()) {
        data['casinoId'] = this.casinoId;
      }
    }
    if (!data?.hasOwnProperty('secondary_player_casino_Id') && this.secondaryPlayerCasinoId?.length > 0) {
      data['secondary_player_casino_Id'] = this.secondaryPlayerCasinoId?.map((id: any) => ({ id: id?.casinoNumber }));
    }

    if (this._conf.isGoogleTagManager && this._conf.tagGoogleManagerId !== '') {
      if (this._conf.cookieRequired && this._conf.policyCookie) window.dataLayer.push(data);
      else if (!this._conf.cookieRequired) window.dataLayer.push(data);
    }
  }

  gaArrayExec() {
    if (this.gaArray?.length) {
      this.gaArray?.forEach((data): void => {
        this.triggerGoogleEvents(data?.eventName, data?.data);
      });
      this.gaArray.length = 0;
    }
  }

  getGuests(data) {
    let val = '';
    for (const [key, value] of Object.entries(data)) {
      let it = '';
      if (value > 0) {
        it = `${value}${key.substring(0, 3).toUpperCase()}`;
      }
      if (it) val = val ? `${val}-${it}` : it;
    }
    return val;
  }

  viewOffersList(offers, propertyId, tenantId, currency?, casinoNumber?): void {
    const transactionData = {
      item_list_name: 'offers',
      ...(!!casinoNumber && casinoNumber !== 'NA' && { casino_Id: casinoNumber }),
      item_category: 'offers',
    };
    let itemsData = [];
    offers?.forEach((offer, index) => {
      itemsData.push({
        item_id: `SKU_Offer-${offer?.offer}_Offer_Description-${offer?.offerDescription}_Property_ID-${propertyId}_Tenant_ID-${tenantId}`,
        item_name: offer?.offer,
        affiliation: propertyId,
        currency: currency,
        index: index,
        item_brand: tenantId,
        quantity: 1,
      });
    });
    transactionData['items'] = itemsData;
    this.triggerGoogleEvents('view_item_list', transactionData);
  }

  getSelectedDates(item): { startDate; endDate } {
    const rateSnapshotLength = item?.rateSnapshot.length;
    const startDate = item?.rateSnapshot[0]?.date;
    const endDate = item?.rateSnapshot[rateSnapshotLength - 1]?.date;
    return {
      startDate,
      endDate,
    };
  }

  viewRoomList(room, casinoNumber?, propertyName?, currencyCode?, propertyId?): void {
    let itemData = [];
    const transactionData = {
      item_list_name: 'room',
      item_list_offerCode: `${room?.offers[0]?.offerCode}`,
      ...(!!casinoNumber && casinoNumber !== 'NA' && { casino_Id: casinoNumber }),
      item_category: 'room',
    };

    room?.offers[0]?.roomTypes.forEach((room, index): void => {
      const { startDate, endDate } = this.getSelectedDates(room);
      itemData.push({
        item_id: `SKU_${room?.roomType}_${room?.roomCode}_${room?.roomName}_Number_Of_Days${
          room?.days
        }_startDate-${startDate}_endDate-${endDate}_CasinoNo.-${casinoNumber || 'NA'}`,
        item_name: room?.roomName,
        affiliation: this._conf?.propertyId,
        coupon: transactionData?.item_list_offerCode,
        currency: currencyCode,
        index: index,
        item_brand: this._conf?.tenantId,
        tax: room?.quoteTotalTax,
        price: room?.quoteTotal,
        quantity: 1,
      });
    });
    transactionData['items'] = itemData;
    this.triggerGoogleEvents('view_item_list', transactionData);
  }

  viewRoomItem(room, index, offerCode, casinoNumber, currencyCode, propertyName?, propertyId?): void {
    const { startDate, endDate } = this.getSelectedDates(room);
    const transactionData = {
      currency: currencyCode,
      value: room?.quoteTotal,
      ...(!!casinoNumber && casinoNumber !== 'NA' && { casino_Id: casinoNumber }),
      item_category: 'room',
    };

    transactionData['items'] = [
      {
        item_id: `SKU_${room?.roomType}_${room?.roomCode}_${room?.roomName}_Number_Of_Days-${
          room?.days
        }_startDate-${startDate}_endDate-${endDate}_CasinoNo.-${casinoNumber || 'NA'}`,
        item_name: room?.roomName,
        affiliation: this._conf?.propertyId,
        coupon: offerCode,
        currency: currencyCode,
        index: index,
        item_brand: this._conf?.tenantId,
        tax: room?.quoteTotalTax,
        price: room?.quoteTotal,
        quantity: 1,
      },
    ];
    this.triggerGoogleEvents('view_item', transactionData);
  }

  viewEnhancementList(enhancements, casinoNumber, currencyCode, propertyName?, propertyId?): void {
    enhancements.forEach((enhance, index) => {
      if (enhance.Success) {
        const transactionData = {
          item_list_name: 'room_enhancement',
          item_list_offerCode: `${enhance?.offerCode}`,
          ...(!!casinoNumber && casinoNumber !== 'NA' && { casino_Id: casinoNumber }),
          item_category: 'room_enhancement',
        };

        let itemData = [];
        enhance?.enhancements?.forEach((enhancement, index): void => {
          itemData.push({
            item_id: `SKU_enhancement_Room_Code-${enhance?.roomCode}_Room_Name-${enhance?.roomName}_startDate-${enhance.ArrivalDate}_endDate-${enhance.DepartureDate}`,
            item_name: enhance?.roomName,
            affiliation: this._conf?.propertyId,
            coupon: transactionData?.item_list_offerCode,
            currency: currencyCode,
            index: index,
            item_brand: this._conf?.tenantId,
            tax: enhancement?.recurringChargeTaxTotal,
            price: enhancement?.recurringChargeTotal,
            quantity: 1,
          });
        });
        transactionData['items'] = itemData;
        this.triggerGoogleEvents('view_item_list', transactionData);
      }
    });
  }

  eventsRemovedFromCart(data): void {
    let transactionData = {
      ...(!!data?.casinoId && data?.casinoId !== 'NA' && { casino_Id: data?.casinoId }),
    };
    let itemData = [];

    transactionData['value'] = data?.price;
    transactionData['currency'] = data.currency;
    transactionData['affiliation'] = this._conf?.propertyId;
    transactionData['booking_type'] = data?.cart_type;

    itemData.push({
      item_id: data?.SKU,
      item_name: data?.itemName,
      affiliation: this._conf?.propertyId,
      coupon: data?.coupon,
      currency: data?.currency,
      item_brand: this._conf?.tenantId,
      index: data?.index,
      item_category: data?.brand_category,
      tax: data?.tax,
      price: data?.value,
      quantity: 1,
    });
    transactionData['items'] = itemData;
    this.triggerGoogleEvents('remove_from_cart', transactionData);
  }
}

export interface EventData {
  transactionId?: string;
  value: number;
  currency: string;
  tax: number;
  affiliation: string;
  cart_type: string;
  SKU: string;
  coupon?: string;
  brand_category: string;
  price: number;
  quantity?: number;
  index?: number;
  itemName?: string;
  item_brand?: string;
}
